import * as ar_001 from 'd3-format/locale/ar-001.json'
import * as ar_AE from 'd3-format/locale/ar-AE.json'
import * as ar_BH from 'd3-format/locale/ar-BH.json'
import * as ar_DJ from 'd3-format/locale/ar-DJ.json'
import * as ar_DZ from 'd3-format/locale/ar-DZ.json'
import * as ar_EG from 'd3-format/locale/ar-EG.json'
import * as ar_EH from 'd3-format/locale/ar-EH.json'
import * as ar_ER from 'd3-format/locale/ar-ER.json'
import * as ar_IL from 'd3-format/locale/ar-IL.json'
import * as ar_IQ from 'd3-format/locale/ar-IQ.json'
import * as ar_JO from 'd3-format/locale/ar-JO.json'
import * as ar_KM from 'd3-format/locale/ar-KM.json'
import * as ar_KW from 'd3-format/locale/ar-KW.json'
import * as ar_LB from 'd3-format/locale/ar-LB.json'
import * as ar_LY from 'd3-format/locale/ar-LY.json'
import * as ar_MA from 'd3-format/locale/ar-MA.json'
import * as ar_MR from 'd3-format/locale/ar-MR.json'
import * as ar_OM from 'd3-format/locale/ar-OM.json'
import * as ar_PS from 'd3-format/locale/ar-PS.json'
import * as ar_QA from 'd3-format/locale/ar-QA.json'
import * as ar_SA from 'd3-format/locale/ar-SA.json'
import * as ar_SD from 'd3-format/locale/ar-SD.json'
import * as ar_SO from 'd3-format/locale/ar-SO.json'
import * as ar_SS from 'd3-format/locale/ar-SS.json'
import * as ar_SY from 'd3-format/locale/ar-SY.json'
import * as ar_TD from 'd3-format/locale/ar-TD.json'
import * as ar_TN from 'd3-format/locale/ar-TN.json'
import * as ar_YE from 'd3-format/locale/ar-YE.json'
import * as ca_ES from 'd3-format/locale/ca-ES.json'
import * as cs_CZ from 'd3-format/locale/cs-CZ.json'
import * as de_CH from 'd3-format/locale/de-CH.json'
import * as de_DE from 'd3-format/locale/de-DE.json'
import * as en_CA from 'd3-format/locale/en-CA.json'
import * as en_GB from 'd3-format/locale/en-GB.json'
import * as en_IN from 'd3-format/locale/en-IN.json'
import * as en_US from 'd3-format/locale/en-US.json'
import * as es_ES from 'd3-format/locale/es-ES.json'
import * as es_MX from 'd3-format/locale/es-MX.json'
import * as fi_FI from 'd3-format/locale/fi-FI.json'
import * as fr_CA from 'd3-format/locale/fr-CA.json'
import * as fr_FR from 'd3-format/locale/fr-FR.json'
import * as he_IL from 'd3-format/locale/he-IL.json'
import * as hu_HU from 'd3-format/locale/hu-HU.json'
import * as it_IT from 'd3-format/locale/it-IT.json'
import * as ja_JP from 'd3-format/locale/ja-JP.json'
import * as ko_KR from 'd3-format/locale/ko-KR.json'
import * as mk_MK from 'd3-format/locale/mk-MK.json'
import * as nl_NL from 'd3-format/locale/nl-NL.json'
import * as pl_PL from 'd3-format/locale/pl-PL.json'
import * as pt_BR from 'd3-format/locale/pt-BR.json'
import * as ru_RU from 'd3-format/locale/ru-RU.json'
import * as sv_SE from 'd3-format/locale/sv-SE.json'
import * as uk_UA from 'd3-format/locale/uk-UA.json'
import * as zh_CN from 'd3-format/locale/zh-CN.json'

export const lookup = {
	ar_001: ar_001,
	ar_AE: ar_AE,
	ar_BH: ar_BH,
	ar_DJ: ar_DJ,
	ar_DZ: ar_DZ,
	ar_EG: ar_EG,
	ar_EH: ar_EH,
	ar_ER: ar_ER,
	ar_IL: ar_IL,
	ar_IQ: ar_IQ,
	ar_JO: ar_JO,
	ar_KM: ar_KM,
	ar_KW: ar_KW,
	ar_LB: ar_LB,
	ar_LY: ar_LY,
	ar_MA: ar_MA,
	ar_MR: ar_MR,
	ar_OM: ar_OM,
	ar_PS: ar_PS,
	ar_QA: ar_QA,
	ar_SA: ar_SA,
	ar_SD: ar_SD,
	ar_SO: ar_SO,
	ar_SS: ar_SS,
	ar_SY: ar_SY,
	ar_TD: ar_TD,
	ar_TN: ar_TN,
	ar_YE: ar_YE,
	ca_ES: ca_ES,
	cs_CZ: cs_CZ,
	de_CH: de_CH,
	de_DE: de_DE,
	en_CA: en_CA,
	en_GB: en_GB,
	en_IN: en_IN,
	en_US: en_US,
	es_ES: es_ES,
	es_MX: es_MX,
	fi_FI: fi_FI,
	fr_CA: fr_CA,
	fr_FR: fr_FR,
	he_IL: he_IL,
	hu_HU: hu_HU,
	it_IT: it_IT,
	ja_JP: ja_JP,
	ko_KR: ko_KR,
	mk_MK: mk_MK,
	nl_NL: nl_NL,
	pl_PL: pl_PL,
	pt_BR: pt_BR,
	ru_RU: ru_RU,
	sv_SE: sv_SE,
	uk_UA: uk_UA,
	zh_CN: zh_CN
}

